<template>
 
  <div class="card_box" v-if="weather">
    <div class="card">
      <h1>{{ weather?.name }}</h1>
      <h3>{{ weather?.weather[0].main }}</h3>
      <h1 v-if="weather">
        <img
          :src="
            'https://openweathermap.org/img/w/' +
            weather?.weather[0].icon +
            '.png'
          "
          style="color: white"
        />
      </h1>

      <h3 v-if="weather">{{ weather?.main?.temp }}&deg;C</h3>
      <br />
      <h3 style="text-transform:capitalize;">{{ weather?.weather[0].description }}</h3>
      <h3>
        {{ weather?.main?.temp_min }}&deg;C /
        {{ weather?.main?.temp_max }}&deg;C | Feels Like :
        {{ weather?.main?.feels_like }}&deg;C
      </h3>
      <!-- <h3>{{ weather?.sys?.sunrise }} | {{ weather?.sys?.sunset }}</h3> -->

      <h3>{{ weather?.sys?.country }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "dataShow",
  props: ["weather"],
};
</script>

<style>
.card_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* width: 80%; */
  height: auto;
}
.card {
  width: 80vh;
  display: flex;
  text-align: center;
  flex-direction: column;
  color: white;
  background: rgba(0, 0, 0, 0.7);
}
</style>